import fetchApi from "../fetchApi";
export const CreateUser = async ({firstName, lastName, email, role, office_ids, phone}) => {

    if(Array.isArray(office_ids) && office_ids.length === 0 ){
        office_ids = '';
    }

    const options = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
            "first_name": firstName,
            "last_name": lastName,
            "email": email,
            "role_id": role,
            "office_ids": office_ids,
            "phone_number": phone
        }),
        redirect: 'follow'
    }

    return await fetchApi('users', options);

};
